@if (value !== TickCrossValue.empty) {
  <mat-icon [class]="['tick-cross', 'tick-cross--' + value]">{{valueIcon[value]}}</mat-icon>
}